<div class="menu-items">
    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/leads-crm/rental-lead'}" (click)="selectMenu('rental-lead')" *ngIf="enableRentalLeadSubMenu">
        Rental Lead Routing<span></span>
    </div>
</div>

<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onConfirm)="selectMenuConfirmation()"
  #changeMenuModal
>
</app-search-update-confirmation>
